import React from "react";
import { Link } from "react-router-dom";

import Figure from "../components/Figure";

function Portfolio() {
  return (
    <div className="Portfolio-wrapper" id="portfolio">
      <h2 className="port-title">Vybrané reference</h2>
      <div className="main-item">
        {/* <div className="main-item-cta">
          <h5 className="port-item-title">kuchyně Nováků</h5>
          <Link to="/projekty/kuchyne-novaku">
            <button className="port-btn">více informací</button>
          </Link>
        </div> */}
      </div>
      <h3 className="port-subtitle">Dokážeme toho víc!</h3>

      <div className="figure-grid">
        <div className="grid-item">
          <a href="/projekty/kuchyne">
            <Figure type="kitchen" desc="kuchyně" styleName="figure-img-1" />
          </a>
        </div>
        <div className="grid-item">
          <a href="/projekty/pokoje">
            <Figure type="room" desc="pokoje" styleName="figure-img-2" />
          </a>
        </div>
        <div className="grid-item">
          <a href="/projekty/loznice">
            <Figure type="restaurant" desc="ložnice" styleName="figure-img-3" />
          </a>
        </div>
        <div className="grid-item">
          <a href="/projekty/predsine">
            <Figure type="furniture" desc="předsíně" styleName="figure-img-4" />
          </a>
        </div>
        <div className="grid-item">
          <a href="/projekty/koupelny">
            <Figure
              type="reception"
              desc="koupelnový nábytek"
              styleName="figure-img-5"
            />
          </a>
        </div>
        <div className="grid-item">
          <a href="/projekty/ostatni">
            <Figure type="office" desc="ostatní" styleName="figure-img-6" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Portfolio;



// WEBPACK FOOTER //
// ./src/components/Portfolio.js